var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18.5001C16.283 19.1569 16.4016 19.1117 15.8886 19.5867C15.1277 20.2913 13.9544 20.6021 11.6078 21.2238C9.26117 21.8454 8.08787 22.1562 7.07249 21.9222C6.27077 21.7373 5.54248 21.3216 4.97972 20.7276C4.267 19.9753 3.95262 18.8153 3.32385 16.4953L2.7852 14.5079C2.15643 12.1879 1.84205 11.0279 2.0788 10.024C2.26574 9.23142 2.68622 8.51139 3.28706 7.95502C4.04803 7.25038 5.22133 6.93957 7.56793 6.31793C8.01187 6.20032 7.63317 6.41163 8 6.31786",
    stroke: "#081E54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6924 9.70508L16.0902 11.1514",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.82324 12.9453L13.0619 13.8131",
    stroke: "#081E54",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6915 13.6486L20.2239 11.7165C20.8454 9.46113 21.1561 8.33345 20.9221 7.35756C20.7373 6.587 20.3217 5.88703 19.7278 5.34616C18.9757 4.66115 17.816 4.35899 15.4965 3.75467C13.1771 3.15035 12.0174 2.84819 11.0138 3.07574C10.2213 3.2554 9.50147 3.65953 8.94523 4.23702C8.34207 4.86321 8.02754 5.77991 7.55948 7.44616C7.48086 7.72602 7.39791 8.02703 7.30854 8.35137L7.30852 8.35143L6.77611 10.2835C6.15462 12.5389 5.84388 13.6665 6.07789 14.6424C6.26266 15.413 6.67827 16.113 7.27216 16.6538C8.02432 17.3388 9.18403 17.641 11.5035 18.2453L11.5035 18.2453C13.5941 18.79 14.7425 19.0892 15.6837 18.9764C15.7867 18.964 15.8872 18.9467 15.9862 18.9243C16.7787 18.7446 17.4985 18.3405 18.0548 17.763C18.7592 17.0316 19.07 15.9039 19.6915 13.6486Z",
    stroke: "#081E54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplies);
export default __webpack_public_path__ + "static/media/Applies.69a9a7952ee7108c1a9ad4e8e0338869.svg";
export { ForwardRef as ReactComponent };